import {View} from "./View"
export const ReportDocumentLink =  ()=> {
    return(
        <View />
    )
}
